import { render, staticRenderFns } from "./ViewGuidancePage.vue?vue&type=template&id=c49d68a0&scoped=true&"
import script from "./ViewGuidancePage.vue?vue&type=script&lang=js&"
export * from "./ViewGuidancePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewGuidancePage.vue?vue&type=style&index=0&id=c49d68a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49d68a0",
  null
  
)

export default component.exports